import { useEffect, useState } from "react";

// True while the window is narrower than `width`. For pickers whose popups are
// laid out for a wide screen (the two-month date range calendar), so they can
// switch to a compact form on small laptops instead of running off the page.
export const useNarrowWindow = (width) => {
  const query = `(max-width: ${width - 1}px)`;
  const [narrow, setNarrow] = useState(() => window.matchMedia?.(query).matches ?? false);

  useEffect(() => {
    const list = window.matchMedia?.(query);
    if (!list) return undefined;
    const update = () => setNarrow(list.matches);
    update();
    list.addEventListener("change", update);
    return () => list.removeEventListener("change", update);
  }, [query]);

  return narrow;
};
